import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgMultiCarousel.messages';
import styles from './SgMultiCarousel.module.scss';

function SgMultiCarousel(props) {
    const {
        carouselSet,
        product,
        className
    } = props;
    const translator = useContext(TranslatorContext);
    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 4,
            slidesToSlide: 4
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 768
            },
            items: 3,
            slidesToSlide: 3
        },
        tabletPortrait: {
            breakpoint: {
                max: 768,
                min: 540
            },
            items: 2,
            slidesToSlide: 2
        },
        mobile: {
            breakpoint: {
                max: 580,
                min: 0
            },
            items: 1,
            slidesToSlide: 1
        }
    };
    const [currentSlidesPageNumber, setCurrentSlidesPageNumber] = useState(1);

    const ButtonGroup = ({
        next,
        previous,
        goToSlide,
        ...rest
    }) => {
        const {
            carouselState: {
                currentSlide,
                slidesToShow,
                totalItems
            }
        } = rest;
        const totalSlidesPagesNumber = Math.ceil(totalItems / slidesToShow);

        if (currentSlidesPageNumber > totalSlidesPagesNumber) {
            setCurrentSlidesPageNumber(totalSlidesPagesNumber);
        }

        const clickBackButton = () => {
            if (currentSlidesPageNumber !== 1) {
                setCurrentSlidesPageNumber(currentSlidesPageNumber - 1);
            }
            previous();
        };

        const clickNextButton = () => {
            if (currentSlidesPageNumber !== totalSlidesPagesNumber) {
                setCurrentSlidesPageNumber(currentSlidesPageNumber + 1);
            }
            next();
        };

        return (
            <div className={styles.carouselButtonGroup}>
                <div className={styles.carouselButtonGroupHeader}>
                    <div className={styles.carouselButtonGroupHeaderContainer}>
                        <h2>
                            {translator(messages.CarouselHeader, { product: product })}
                        </h2>
                    </div>
                    <p>{translator(messages.CarouselSubHeader, { product: product.toLowerCase() })}</p>
                </div>
                <div className={styles.navButtons}>
                    <div className={styles.sgCarouselButtonLeft}>
                        <button type="button" className={currentSlide === 0 ? 'disabled' : ''} onClick={() => clickBackButton()} />
                    </div>
                    <p>
                        {currentSlidesPageNumber}
                        /
                        {totalSlidesPagesNumber}
                    </p>
                    <div className={styles.sgCarouselButtonRight}>
                        <button
                            type="button"
                            className={currentSlidesPageNumber === totalSlidesPagesNumber ? 'disabled' : ''}
                            onClick={() => clickNextButton()}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const openLink = (event, url) => {
        event.preventDefault();
        window.open(url);
    };

    return (
        <Carousel
            responsive={responsive}
            containerClass={classNames(styles.carouselContainer, className)}
            arrows={false}
            customButtonGroup={<ButtonGroup />}
        >
            {carouselSet.map((carouselOject) => (
                <div
                    key={carouselOject.name}
                    className={styles.containerItem}
                    onClick={(event) => openLink(event, carouselOject.url)}
                    onKeyPress={(event) => openLink(event, carouselOject.url)}
                    aria-hidden="true"
                >
                    <div
                        className={`sg-multi-carousel-image sg-${translator(carouselOject.name)}-image`}
                    />
                    {carouselOject.text ? (
                        <div className={styles.carouselTextContainer}>
                            <h3 className={styles.header}>
                                {translator(carouselOject.text.header)}
                            </h3>
                            <p className={styles.description}>
                                {translator(carouselOject.text.description)}
                            </p>
                        </div>
                    ) : null}
                </div>
            ))}
        </Carousel>
    );
}

SgMultiCarousel.defaultProps = {
    carouselSet: [],
    product: undefined,
    className: undefined
};

export default SgMultiCarousel;
